import React from 'react';
import logo from '../assets/qualiz-logo.svg';

export function LoadingDashboard({ message = 'Loading your dashboard…' }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-gray-800">
      <div className="relative w-28 h-28 flex items-center justify-center">
        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-blue-500/10 via-indigo-500/10 to-purple-500/10 animate-ping" />
        <div className="w-full h-full flex items-center justify-center">
          <img src={logo} alt="Qualiz" className="w-20 h-20 object-contain drop-shadow" />
        </div>
      </div>
      <p className="mt-4 text-sm font-medium tracking-wide opacity-80">{message}</p>
    </div>
  );
}
